import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from "../../components/Common/DataTableContainer";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { deleteBranch, updateBranch } from "store/actions";
import CreateBranch from "./CreateBranch";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const BranchTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [confirmAction, setConfirmAction] = useState();
  const [openModal, setOpenModal] = useState();

  const permissions = JSON.parse(localStorage?.getItem("permissions"));
  const hasDeletePermission = permissions.some(
    (item) => item?.permissionName === "Delete Branch"
  );
  const hasEditPermission = permissions.some(item => item?.permissionName === "Edit Branch");

  const handleDelete = (branchId) => {
    dispatch(deleteBranch(branchId));
    setDeleteId("");
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: "Branch Name",
        accessorKey: "branchName",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Address",
        accessorKey: "branchAddress",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <span
            style={{
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              display: 'block',
              maxWidth: '400px', // You can adjust this based on your design
            }}
          >
            {row.original?.branchAddress}
          </span>
        )
      },
      ...(hasDeletePermission || hasEditPermission
        ? [
          {
            header: "Actions",
            id: "actions",
            cell: ({ row }) => {
              return (
                <div className="d-flex gap-2">
                  {hasEditPermission && <Button
                    color="primary"
                    onClick={() => {
                      setEditData(row?.original);
                      setIsOpen(true);
                    }}
                  >
                    <FaRegEdit size={18} />
                  </Button>}
                  {hasDeletePermission && <Button
                    color="danger"
                    onClick={() => {
                      setDeleteId(row?.original?.branchId);
                      setOpenModal(true);
                    }}
                  >
                    <MdDeleteOutline size={18} />
                  </Button>}
                </div>
              );
            },
          },
        ]
        : []),
    ],
    [hasDeletePermission, hasEditPermission]
  );

  const handleSubmit = (data) => {
    dispatch(updateBranch(data));
  };

  const handleClose = () => {
    setIsOpen(false);
    setEditData("");
  };

  document.title = "Branch Management";

  return (
    <>
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => {
          setDeleteId("");
          setOpenModal(false);
        }}
        onOk={() => {
          setConfirmAction(true);
        }}
        isVisible={openModal}
        title="Delete Branch"
        content="Are you sure you want to delete this branch?"
      />
      <CreateBranch
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />
      <div className="">
        <div className="container-fluid">
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Branches"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default BranchTable;
